import { render } from "./GalleryGridItem2.vue?vue&type=template&id=27851834&scoped=true"
import script from "./GalleryGridItem2.vue?vue&type=script&lang=js"
export * from "./GalleryGridItem2.vue?vue&type=script&lang=js"

import "./GalleryGridItem2.vue?vue&type=style&index=0&id=27851834&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27851834"]])

export default __exports__